<app-content-page-layout title="Friends">
  <!-- Add friend button -->
  <div pageActions class="">
    <button
      (click)="openAddFriendModal()"
      class="flex gap-2 px-4 py-2 bg-blue-700 hover:bg-blue-800 text-white text-sm font-semibold rounded-lg transition"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Add Friend
    </button>
  </div>
  <!-- Tabs -->
  <div class="sm:hidden">
    <select
      (change)="onSelectChange($event)"
      [value]="activeTab()"
      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
    >
      <option value="friends" [selected]="activeTab() === 'friends'">My friends</option>
      <option value="incoming" [selected]="activeTab() === 'incoming'">Incoming Requests</option>
      <option value="outgoing" [selected]="activeTab() === 'outgoing'">Outgoing Requests</option>
    </select>
  </div>
  <ul
    class="hidden text-sm font-medium text-center text-gray-500 rounded-lg shadow-sm sm:flex dark:divide-gray-700 dark:text-gray-400"
  >
    <li class="w-full focus-within:z-10">
      <button
        (click)="setTab('friends')"
        [ngClass]="
          activeTab() === 'friends'
            ? 'text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white'
            : 'bg-white dark:bg-gray-800'
        "
        class="inline-block w-full p-4 border-r border-gray-200 dark:border-gray-700 hover:text-gray-700 hover:bg-gray-100 dark:hover:text-white dark:hover:bg-gray-700 focus:outline-none transition rounded-s-lg"
        aria-current="page"
      >
        My friends
      </button>
    </li>
    <li class="w-full focus-within:z-10">
      <button
        (click)="setTab('incoming')"
        [ngClass]="
          activeTab() === 'incoming'
            ? 'text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white'
            : 'bg-white dark:bg-gray-800'
        "
        class="inline-block w-full p-4 border-r border-gray-200 dark:border-gray-700 hover:text-gray-700 hover:bg-gray-100 dark:hover:text-white dark:hover:bg-gray-700 focus:outline-none transition"
      >
        Incoming
      </button>
    </li>
    <li class="w-full focus-within:z-10">
      <button
        (click)="setTab('outgoing')"
        [ngClass]="
          activeTab() === 'outgoing'
            ? 'text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white'
            : 'bg-white dark:bg-gray-800'
        "
        class="inline-block w-full p-4 border-r border-gray-200 dark:border-gray-700 hover:text-gray-700 hover:bg-gray-100 dark:hover:text-white dark:hover:bg-gray-700 focus:outline-none transition rounded-e-lg"
      >
        Outgoing
      </button>
    </li>
  </ul>
  <!-- Tab Content -->
  <div class="mt-8">
    <!-- Friends List -->
    @if (activeTab() === 'friends') {
      @if (friends.length > 0) {
        <ul class="flex flex-col gap-3">
          @for (friend of friends; track friend.id) {
            <div class="flex items-center justify-between rounded-2xl">
              <!-- Avatar -->
              <app-avatar
                [imageSrc]="'https://picsum.photos/200/300'"
                [username]="friend.username"
                subtitle="Full Name"
              ></app-avatar>
              <!-- Button Elements -->
              <div class="flex gap-2">
                <button
                  (click)="openInviteToHouseholdModal(friend)"
                  class="px-3 py-1 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition"
                >
                  Invite
                </button>
                <button
                  (click)="remove(friend.id)"
                  class="px-3 py-1 text-sm font-semibold bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white hover:bg-gray-300 text-black rounded-lg transition"
                >
                  Unfriend
                </button>
              </div>
            </div>
          }
        </ul>
      } @else {
        <div class="flex items-center justify-center h-48">
          <h1 class="text-gray-400 text-2xl font-bold text-center">No friends yet :(</h1>
        </div>
      }
    }
    <!-- Incoming Requests -->
    @else if (activeTab() === 'incoming') {
      @if (incomingRequests.length > 0) {
        <ul class="flex flex-col gap-3">
          @for (req of incomingRequests; track req.id) {
            <div class="flex items-center justify-between rounded-2xl">
              <!-- Avatar -->
              <app-avatar
                [imageSrc]="'https://picsum.photos/200/300'"
                [username]="req.from_username"
                subtitle="Full Name"
              ></app-avatar>
              <!-- Button Elements -->
              <div class="flex gap-2">
                <button
                  (click)="respond(req.id, true)"
                  class="px-3 py-1 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition"
                >
                  Accept
                </button>
                <button
                  (click)="respond(req.id, false)"
                  class="px-3 py-1 text-sm font-semibold bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white hover:bg-gray-300 text-black rounded-lg transition"
                >
                  Decline
                </button>
              </div>
            </div>
          }
        </ul>
      } @else {
        <div class="flex items-center justify-center h-48">
          <h1 class="text-gray-400 text-2xl font-bold text-center">No incoming requests</h1>
        </div>
      }
    }
    <!-- Outgoing Requests -->
    @else if (activeTab() === 'outgoing') {
      @if (outgoingRequests.length > 0) {
        <ul class="flex flex-col gap-3">
          @for (req of outgoingRequests; track req.id) {
            <div class="flex items-center justify-between rounded-2xl">
              <!-- Avatar -->
              <app-avatar
                [imageSrc]="'https://picsum.photos/200/300'"
                [username]="req.to_username"
                subtitle="Full Name"
              ></app-avatar>
              <!-- Button Elements -->
              <div class="flex gap-2">
                <button
                  (click)="revoke(req.id)"
                  class="px-3 py-1 text-sm font-semibold bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white hover:bg-gray-300 text-black rounded-lg transition"
                >
                  Revoke
                </button>
              </div>
            </div>
          }
        </ul>
      } @else {
        <div class="flex items-center justify-center h-48">
          <h1 class="text-gray-400 text-2xl font-bold text-center">No outgoing requests</h1>
        </div>
      }
    }
    <!-- Fall-back -->
    @else {
      <div class="flex items-center justify-center h-48">
        <h1 class="text-gray-400 text-2xl font-bold text-center">Nothing to see here</h1>
      </div>
    }
  </div>
</app-content-page-layout>

<!-- Add friend modal -->
@if (addFriendModalOpen) {
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/40" (click)="addFriendModalOpen = false"></div>
    <!-- Dialog -->
    <div
      class="relative w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700"
    >
      <h2 class="text-lg font-bold text-gray-800 dark:text-white mb-4">Send Friend Request</h2>

      <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1"
        >Username</label
      >
      <input
        type="text"
        [(ngModel)]="addFriendModalUsername"
        placeholder="Enter username"
        autocomplete="off"
        (keydown.enter)="sendRequest()"
        class="w-full px-3 py-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white mb-3"
      />

      @if (addFriendModalError) {
        <p class="text-red-600 text-xs mb-3">{{ addFriendModalError }}</p>
      }

      <div class="flex gap-2 justify-end">
        <button
          (click)="addFriendModalOpen = false"
          class="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 dark:bg-gray-600 dark:text-white rounded-lg hover:bg-gray-200 dark:hover:bg-gray-500 transition"
        >
          Cancel
        </button>
        <button
          (click)="sendRequest()"
          [disabled]="addFriendModalLoading || !addFriendModalUsername.trim()"
          class="px-4 py-2 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ addFriendModalLoading ? 'Sending...' : 'Send Request' }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Invite to household modal -->
@if (inviteToHouseholdModalOpen) {
  <div class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/40" (click)="inviteToHouseholdModalOpen = false"></div>
    <!-- Dialog -->
    <div
      class="relative w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700"
    >
      <h2 class="text-lg font-bold text-gray-800 dark:text-white mb-4">
        Invite {{ inviteToHouseholdModalUser.username }} to a Household
      </h2>

      <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1"
        >Household</label
      >
      <select
        (change)="onHouseholdSelectChange($event)"
        [value]="inviteToHouseholdModalHouseholdId"
        (keydown.enter)="sendInvitation()"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 mb-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
      >
        @for (hh of households | async; track hh.id) {
          <option value="{{ hh.id }}">{{ hh.name }}</option>
        }
      </select>

      @if (inviteToHouseholdModalError) {
        <p class="text-red-600 text-xs mb-3">{{ inviteToHouseholdModalError }}</p>
      }

      <div class="flex gap-2 justify-end">
        <button
          (click)="inviteToHouseholdModalOpen = false"
          class="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 dark:bg-gray-600 dark:text-white rounded-lg hover:bg-gray-200 dark:hover:bg-gray-500 transition"
        >
          Cancel
        </button>
        <button
          (click)="sendInvitation()"
          [disabled]="inviteToHouseholdModalLoading || !inviteToHouseholdModalHouseholdId"
          class="px-4 py-2 text-sm font-semibold bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ inviteToHouseholdModalLoading ? 'Sending...' : 'Send Invitation' }}
        </button>
      </div>
    </div>
  </div>
}
